import { Link } from 'react-router-dom';
import { articles } from '@/mocks/shows';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-4">
          准备好开始你的综艺之旅了吗？
        </h2>
        <p className="text-foreground-500 text-sm md:text-base mb-8 max-w-xl mx-auto">
          数千部热门综艺等你来看，高清画质，极速播放，全程无广告打扰。现在就加入星辰影院，开启无限欢乐！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/hot"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            立即探索热门综艺
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full border-2 border-background-300 text-foreground-700 font-medium text-sm hover:border-primary-400 hover:text-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}